import { usePageTracking } from 'hooks/mixpanel/usePageTracking';

const PageTracker = (): null => {
  usePageTracking();
  return null;
};

export default PageTracker;
